/**
 * Shared actions
 * @namespace shared_actions
 * @category Redux
 * @subcategory Actions
 */
// eslint-disable-next-line
const shared_actions = {};
//used for the namespace in the documentation

/**
 * Shared loading action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function setLoading
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_LOADING", payload: value });
  };
};
/**
 * Shared ready websocket data action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function setReadyWebsocketData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setReadyWebsocketData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_READY_WEBSOCKET_DATA", payload: value });
  };
};
/**
 * Shared ready static data action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function setReadyStaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setReadyStaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_READY_STATIC_DATA", payload: value });
  };
};
/**
 * Shared map dialog action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function setMapDialog
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setMapDialog = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_MAP_DIALOG", payload: value });
  };
};
/**
 * Shared map dialog data action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function setMapDialogData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setMapDialogData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_MAP_DIALOG_DATA", payload: value });
  };
};
/**
 * Shared is drawer open action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function setIsDrawerOpen
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setIsDrawerOpen = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_IS_DRAWER_OPEN", payload: value });
  };
};
/**
 * Shared selected line action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function setSelectedLine
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setSelectedLine = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_SELECTED_LINE", payload: value });
  };
};
/**
 * Shared selected navigation tab action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function setSelectedNavigationTab
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setSelectedNavigationTab = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_SELECTED_NAVIGATION_TAB", payload: value });
  };
};
/**
 * Shared map baselayer action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function setMapBaselayer
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setMapBaselayer = (value) => {
  window.localStorage.setItem("mapName", value.name);
  window.localStorage.setItem("mapURL", value.url);
  window.localStorage.setItem("mapAttribution", value.attribution);
  return (dispatch, getState) => {
    dispatch({ type: "SET_MAP_BASELAYER", payload: value });
  };
};
/**
 * Shared disable wheel zoom action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function disableWheelZoom
 * @param {boolean} bool the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const disableWheelZoom = (bool) => {
  return (dispatch, getState) => {
    dispatch({ type: "DISABLE_WHEEL_ZOOM", payload: bool });
  };
};
/**
 * Shared change map center
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function changeMapCenter
 * @param {boolean} bool the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const changeMapCenter = (bool) => {
  return (dispatch, getState) => {
    dispatch({ type: "CHANGE_MAP_CENTER", payload: bool });
  };
};
/**
 * Shared map zoom action
 * @category Redux
 * @subcategory Actions
 * @memberof shared_actions
 * @function setMapZoom
 * @param {number} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setMapZoom = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_MAP_ZOOM", payload: value });
  };
};
